import { useQuery } from '@tanstack/react-query';

import { Brand, getBrands } from '~/services/ExperiencesService';

export default function useBrands() {
  const { data, isLoading, error } = useQuery<Array<Brand>, Error>({
    queryKey: ['brands'],
    queryFn: async () => {
      const response = await getBrands();
      return response.result;
    },
  });

  return { data: data ?? null, loading: isLoading, error: error ?? null };
}
